import {Controller} from '@hotwired/stimulus'
import Choices from 'choices.js'
import configMerge from '../config-merge'
import {get, debounce} from 'lodash'

export default class extends Controller {
  static targets = ['choices']

  static values = {
    options: Object,
    queryUrl: String,
    minSearchLength: { type: Number, default: 0 }
  }

  loadChoices(query = "") {
    const url = new URL(this.queryUrlValue, window.location.origin)
    url.searchParams.append("q", query)

    return this.choices.setChoices(async () => {
      try {
        const items = await fetch(url.toString(), {
          headers: {
            "Accept": "application/json"
          }
        })

        if (!items.ok) return []

        return await items.json()
      } catch (err) {
        console.error(err)
        return []
      }}, "value", "label", true).then(() => {
          const input = this.element.querySelector("input[type=search]")
          if (input) {
            input.focus()
          }
        }
    )
  }

  queryTyped = debounce(async (e) => {
    const query = e.detail.value?.trim() || ""

    if (query.length < this.minSearchLengthValue) {
      return
    }

    return this.loadChoices(query)
  }, 300);

  initialize() {
    this.choices = new Choices(this.choicesTarget, this.options())
  }

  connect() {
    this.choices.init()

    if (this.queryUrlValue) {
      this.searchHandler = (e) => this.queryTyped(e)
      this.showDropdownHandler = () => this.loadChoices("")
      this.choicesTarget.addEventListener("search", this.searchHandler)
      this.choicesTarget.addEventListener("showDropdown", this.showDropdownHandler)
    }

    const value = this.choicesTarget.dataset?.selectedValue || this.choicesTarget?.value
    if (value) {
      this.choices.setChoiceByValue(value)
    }
  }


  disconnect() {
    if (this.searchHandler) {
      this.choicesTarget.removeEventListener("search", this.searchHandler)
    }

    if (this.showDropdownHandler) {
      this.choicesTarget.removeEventListener("showDropdown", this.showDropdownHandler)
    }

    this.choices.destroy()
  }

  options() {
    return configMerge([this.defaultOptions(), this.optionsValue])
  }

  defaultOptions() {
    return {
      searchEnabled: true,
      allowHTML: false,
      shouldSort: false,
      itemSelectText: ' ',
      noResultsText: 'Δεν βρέθηκαν αποτελέσματα',
      noChoicesText: 'Δεν υπάρχουν επιλογές',
      loadingText: 'Φόρτωση...',
      classNames: {
        containerOuter: [...Array.from(this.choicesTarget.classList), "choices"],
      },
      callbackOnCreateTemplates: function () {
        return {
          choice: function (choicesConfig, choice, selectText) {
            choice.label = get(choice.element, 'dataset.htmlLabel', choice.label)

            return Choices.defaults.templates.choice.call(this, choicesConfig, choice, selectText)
          },
          item: function (choicesConfig, choice, removeItemButton) {
            choice.label = get(choice.element, 'dataset.htmlLabel', choice.label)

            return Choices.defaults.templates.item.call(this, choicesConfig, choice, removeItemButton)
          }
        }
      }
    }
  }
}
